import { Bone, SkeletonFormCard } from '../primitives';

// Matches EditPodcast.js's distribution-tab content: stacked cards (RSS URL, general
// fields, poster image, status toggle, automatic publishing).
export default function EditPodcastSkeleton() {
    return (
        <div className="row">
            <div className="col-xl-8">
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    {[1, 2, 3].map((i) => (
                        <SkeletonFormCard key={i} fields={1} showButton={false} />
                    ))}
                </div>
            </div>
            <div className="col-xl-4">
                <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 16 }}>
                    <Bone h={150} r={10} />
                </div>
            </div>
        </div>
    );
}
